<script setup lang="ts">
const props = withDefaults(defineProps<{
  title?: string
  url: string
}>(), {
  title: 'Video',
})
</script>

<template>
  <UModal
    :title="props.title" :overlay="false" close-icon="bx:x" fullscreen :ui="{
      wrapper: 'dark',
      content: 'bg-primary-50/70 dark:bg-primary-900/70 backdrop-blur-lg',
      header: 'p-2 sm:p-2 py-4 sm:py-4',
      body: 'p-2 sm:p-2 flex justify-center items-center',
      title: 'text-lg text-primary-800 dark:text-primary-50 font-heading text-pretty',
    }"
  >
    <template #default>
      <slot />
    </template>
    <template #body>
      <div class="w-full max-h-full aspect-video flex justify-center">
        <VideoPreviewPlayer :url="props.url" class="border border-primary-600 dark:border-neutral-600 rounded overflow-hidden shadow-xl shadow-primary-100 dark:shadow-primary-800" />
      </div>
    </template>
  </UModal>
</template>
